import React from "react";
import { useNavigate } from "react-router-dom";
import { APP_CONFIG } from "../config/appConfig";

export default function MembershipInfo() {
  const navigate = useNavigate();

  const memberships = [
    {
      type: "Family Membership",
      amount: "$40",
      description: "Includes parents and children under 18 years living in the same household.",
    },
    {
      type: "Single Adult Membership",
      amount: "$30",
      description: "For individual adults (18+).",
    },
    {
      type: "Student Membership",
      amount: "$20",
      description: "For full-time students with valid student ID.",
    },
    {
      type: "Senior Couple Membership",
      amount: "$25",
      description: "Includes two seniors (65+).",
    },
    {
      type: "Family One Adult",
      amount: "$25",
      description: "Single parent with children under 18 years.",
    },
    {
      type: "Senior Single Membership",
      amount: "$15",
      description: "For a single senior (65+).",
    },
  ];

  const handleMembershipClick = (membershipType) => {
    if (!APP_CONFIG.MEMBERSHIP_ENABLED) return; // 🚫 disabled

    const user = localStorage.getItem("member");

    if (user) {
      navigate("/membershipform", { state: { membershipType } });
    } else {
      navigate("/signup", { state: { membershipType } });
    }
  };

  return (
    <section className="relative w-full overflow-hidden">
      <div className="relative z-20 p-6 sm:p-10 max-w-5xl mx-auto animate-fadeIn">

        <h2 className="text-3xl sm:text-4xl font-bold text-center mb-10" style={{ color: "#d4503e" }}>
          Membership
        </h2>

        <p className="mb-6 text-lg text-center">
          Join Airdrie Gujarati Samaj to celebrate tradition and unity.
        </p>

        <h3 className="text-2xl font-semibold mb-6 text-center">
          Membership Options
        </h3>

        {/* 🔥 Clickable Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {memberships.map((m, i) => (
            <div
              key={i}
              onClick={() => handleMembershipClick(m.type)}
              className="cursor-pointer relative bg-white/90 rounded-2xl p-6 shadow-xl border hover:shadow-2xl transition transform hover:-translate-y-1 hover:scale-[1.02]"
            >
              <div className="absolute top-0 left-0 w-full h-2 bg-orange-500"></div>

              <h4 className="text-xl font-bold mb-3 text-center">{m.type}</h4>

              <p className="text-gray-700 text-sm text-center mb-5">
                {m.description}
              </p>

              <div className="flex justify-center">
                <span className="bg-green-100 text-green-700 font-bold px-5 py-2 rounded-full">
                  {m.amount}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="mb-4 text-lg">
            Ready to join? Membership registration starts March 2026
          </p>
        </div>
      </div>
    </section>
  );
}